import { createContext } from 'react';
const AddCartContext = createContext();
export default AddCartContext;